/** Strip "literal:" prefix if present. */
export const resolveLabel = (label: string): string => {
  return label.startsWith('literal:') ? label.slice(8) : label;
};

/** Normalize a legacy URL: strip @/ prefix → /legacy/, ensure leading slash. */
export const normalizeLegacyPath = (url: string): string => {
  if (url.startsWith('@/')) {
    return `/legacy/${url.substring(2)}`;
  }
  return url.startsWith('/') ? url : `/${url}`;
};
